import { initColorSelect, doAjax, updateTableValue, initRedPointLogic } from './helper'
import { loadAlreadyCustomizedOptions, replaceImage } from './interior-general-logic'

const initBicolorSelectLogic = () => {
	initColorSelect()
	const loadOptions = aeo['configuration']['YN1_Q7Q9'] === true
		? {}
		: {}
	loadAlreadyCustomizedOptions(() => {}, loadOptions)
	initRedPointLogic('bicolor', 'dot_bicolor', setImage)
}


function setImage(component, colorCode) {
	const setYN1_A5 = aeo['configuration']['YN1_A5'] === true
	const setYN2_A5 = aeo['configuration']['YN2_A5'] === true
	const setYN3_A5 = aeo['configuration']['YN3_A5'] === true
	const setYN4_A5 = aeo['configuration']['YN4_A5'] === true
	const setYN3_SQ6_perf = aeo['configuration']['YN3_SQ6_perf'] === true
	const setYN4_SQ6_perf = aeo['configuration']['YN4_SQ6_perf'] === true
	const setYN1_A6etron = aeo['configuration']['YN1_A6etron'] === true
	const setYN2_A6etron = aeo['configuration']['YN2_A6etron'] === true
	const setYN1_A6_C9 = aeo['configuration']['YN1_A6_C9'] === true
	const setYN2_A6_C9 = aeo['configuration']['YN2_A6_C9'] === true
	const setYN1_Q7Q9 = aeo['configuration']['YN1_Q7Q9'] === true
	const setYN2_Q7Q9 = aeo['configuration']['YN2_Q7Q9'] === true

	const carModel = document.querySelector("input[name=carmodel]").value;
	const frontSeatModel = document.querySelector("input[name=frontseatmodel]").value;
	const backSeatModel = document.querySelector("input[name=backseatmodel]").value;
	const steering_wheel = document.querySelector("input[name=steering-wheel-model]").value;

	// not every seat has a generic bicolor image (e.g. Q4Q_AU41X_PERF: YN3/YN4 set below)
	var imageSourceFront = aeo['images']['bicolor_' + frontSeatModel + '_front_view']?.[colorCode]
	if ((carModel == 1) || (carModel == 201)) {
		var imageSourceBack = aeo['images']['bicolor_' + backSeatModel + '_back_view'][colorCode]
	}
	if ((carModel == 2) || (carModel == 200)) {
		// only etron RS 
		var imageSourceFront = aeo['images']['bicolor_rs_' + frontSeatModel + '_front_view'][colorCode]		
		var imageSourceBack = aeo['images']['bicolor_' + backSeatModel + '_back_view'][colorCode]
		// only etron RS 
	}
	if ((carModel == 10) || (carModel == 14)) {
		// only rs6rs7 
		var imageSourceBack = aeo['images']['bicolor_rs6rs7_' + backSeatModel + '_back_view'][colorCode]
		// only rs6rs7
	}
	if (carModel == 21) {
		// only rsq8 
		if (steering_wheel == 21) {
			imageSourceFront = aeo['images']['bicolor_' + frontSeatModel + '_front_view_sportkontur'][colorCode]	
		}	
		if (steering_wheel == 22) {
			imageSourceFront = aeo['images']['bicolor_' + frontSeatModel + '_front_view_sportlenkrad'][colorCode]	
		}	
		var imageSourceBack = aeo['images']['bicolor_rsq8_' + backSeatModel + '_back_view'][colorCode]
		// only rsq8 
	}
	if ((carModel == 35) || (carModel == 36) || (carModel == 38) || (carModel == 39)) {
		var imageSourceFront = aeo['images']['bicolor_' + frontSeatModel + '_front_view'][colorCode]	
		var imageSourceBack = aeo['images']['bicolor_' + backSeatModel + '_back_view'][colorCode]
	}
	if ((carModel == 41) || (carModel == 43) || (carModel == 44) || (carModel == 45)) {
		if (setYN1_A5) {
			var imageSourceFront = aeo['images']['bicolor_Q1D_AU401_front_view'][colorCode]	
			var imageSourceBack = aeo['images']['bicolor_A5_N3M_back_view'][colorCode]
		}
		if (setYN2_A5) {
			var imageSourceFront = aeo['images']['bicolor_Q4Q_AU401_front_view'][colorCode]	
			var imageSourceBack = aeo['images']['bicolor_A5_Q4Q_N3M_back_view'][colorCode]
		}
	}
	if ((carModel == 46) || (carModel == 47)) {
		if (setYN3_A5) {
			var imageSourceFront = aeo['images']['bicolor_Q4Q_AU401_YN3_front_view'][colorCode]	
			var imageSourceBack = aeo['images']['bicolor_A5_Q4Q_N3M_YN3_back_view'][colorCode]
		}
		if (setYN4_A5) {
			var imageSourceFront = aeo['images']['bicolor_Q4Q_AU401_YN4_front_view'][colorCode]	
			var imageSourceBack = aeo['images']['bicolor_A5_Q4Q_N3M_YN4_back_view'][colorCode]
		}
	}
	if ((carModel == 51) || (carModel == 53) || (carModel == 54) || (carModel == 55)) {
		if (setYN1_A6etron) {
			var imageSourceFront = aeo['images']['bicolor_Q1D_AU513_front_view'][colorCode]	
			var imageSourceBack = aeo['images']['bicolor_A6_etron_N2S_back_view'][colorCode]
		}
		if (setYN2_A6etron) {
			var imageSourceFront = aeo['images']['bicolor_Q4Q_AU513_front_view'][colorCode]	
			var imageSourceBack = aeo['images']['bicolor_A6_etron_Q4Q_N3M_back_view'][colorCode]
		}
	}
	if ((carModel == 61) || (carModel == 63) || (carModel == 64) || (carModel == 65)) {
		if (setYN1_A6_C9) {
			var imageSourceFront = aeo['images']['bicolor_Q1D_AU592_front_view'][colorCode]	
			var imageSourceBack = aeo['images']['bicolor_A6_C9_N2S_back_view'][colorCode]
		}
		if (setYN2_A6_C9) {
			var imageSourceFront = aeo['images']['bicolor_Q4Q_AU592_front_view'][colorCode]	
			var imageSourceBack = aeo['images']['bicolor_A6_C9_Q4Q_N3M_back_view'][colorCode]
		}
	}
	/* Q7/Q9 steering wheel check */
	var sw_abbr = "2zq";
	if ((steering_wheel == 104)) { sw_abbr = "2zq"; }
	if ((steering_wheel == 105)) { sw_abbr = "2fs"; }
	if ((steering_wheel == 106)) { sw_abbr = "1xy"; }
	/* Q7/Q9 steering wheel check */

	if ((carModel == 115)) {
		if (setYN1_Q7Q9) {
			var imageSourceFront = aeo['images']['bicolor_Q1D_AU546_' + sw_abbr + '_front_view'][colorCode]	
			var imageSourceBack = aeo['images']['bicolor_' + backSeatModel + '_back_view'][colorCode]
		}
		if (setYN2_Q7Q9) {
			var imageSourceFront = aeo['images']['bicolor_Q4Q_AU546_' + sw_abbr + '_front_view'][colorCode]
			var imageSourceBack = aeo['images']['bicolor_yn2_' + backSeatModel + '_back_view'][colorCode]
		}
		
	}

	if ((carModel == 116) || (carModel == 117)) {
		if (setYN1_Q7Q9) {
			var imageSourceFront = aeo['images']['bicolor_Q1D_AU546_' + sw_abbr + '_front_view'][colorCode]
			var imageSourceBack = aeo['images']['bicolor_' + backSeatModel + '_back_view'][colorCode]
		}
		if (setYN2_Q7Q9) {
			var imageSourceFront = aeo['images']['bicolor_Q4Q_AU546_' + sw_abbr + '_front_view'][colorCode]
			var imageSourceBack = aeo['images']['bicolor_yn2_' + backSeatModel + '_back_view'][colorCode]
			console.log("backSeatModel: " + backSeatModel)
		}
		
	}
	
	if ((carModel == 118)) {
		if (setYN1_Q7Q9) {
			var imageSourceFront = aeo['images']['bicolor_Q1D_AU546_' + sw_abbr + '_front_view'][colorCode]	
			var imageSourceBack = aeo['images']['bicolor_' + backSeatModel + '_Q9_back_view'][colorCode]
		}
		if (setYN2_Q7Q9) {
			var imageSourceFront = aeo['images']['bicolor_Q4Q_AU546_' + sw_abbr + '_front_view'][colorCode]
			var imageSourceBack = aeo['images']['bicolor_yn2_' + backSeatModel + '_Q9_back_view'][colorCode]
		}
		
	}

	
	if ((carModel == 119) || (carModel == 120)) {
		if (setYN1_Q7Q9) {
			var imageSourceFront = aeo['images']['bicolor_Q1D_AU546_' + sw_abbr + '_front_view'][colorCode]
			var imageSourceBack = aeo['images']['bicolor_' + backSeatModel + '_Q9_back_view'][colorCode]
		}
		if (setYN2_Q7Q9) {
			var imageSourceFront = aeo['images']['bicolor_Q4Q_AU546_' + sw_abbr + '_front_view'][colorCode]
			var imageSourceBack = aeo['images']['bicolor_yn2_' + backSeatModel + '_Q9_back_view'][colorCode]
		}
		
	}

	
	if ((carModel == 70) || (carModel == 71)) {
		if (setYN3_SQ6_perf) {
			var imageSourceFront = aeo['images']['bicolor_YN3_front_view'][colorCode]
			var imageSourceBack = aeo['images']['bicolor_YN3_back_view'][colorCode]
		}
		if (setYN4_SQ6_perf) {
			var imageSourceFront = aeo['images']['bicolor_YN4_front_view'][colorCode]
			var imageSourceBack = aeo['images']['bicolor_YN4_back_view'][colorCode]
			console.log("backSeatModel: " + backSeatModel)
		}
		
	}


	

	replaceImage(imageSourceFront, component + 'Color', 'car_frontseat')
	replaceImage(imageSourceBack, component + 'Color', 'car_backseat')
	updateTableValue(component, colorCode, 'bicolor-components')
	doAjax({
		'interior_component': component,
		'color': colorCode,
		'src': imageSourceFront
	})
}

export { initBicolorSelectLogic };